<template>
    <div>
        <form class="form--inline form--rounded" @submit.prevent>
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <input
                        class="form__input--text"
                        v-model="first_name"
                        type="text"
                        required
                        :placeholder="$t('account.form.first_name')"
                    />
                </div>
                <div class="col-xs-12 col-md-6">
                    <input
                        class="form__input--text"
                        v-model="last_name"
                        type="text"
                        required
                        :placeholder="$t('account.form.last_name')"
                    />
                </div>
                <div class="col-12">
                    <input
                        v-model="email"
                        type="email"
                        required
                        class="form__input--text"
                        :placeholder="$t('account.subscribe.email')"
                        @keyup.enter="onButton"
                        @focus="emailPH = ''"
                        @blur="emailPH = 'form.your_email'"
                    />
                </div>
            </div>
            <input
                type="submit"
                class="button--alt button--rounded"
                @click="onButton"
                :disabled="loading"
                :value="$t('account.subscribe.signup')"
            />
        </form>
        <div v-if="success" class="form__success">{{ success }}</div>
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SignUpForm extends Vue {
    first_name = '';
    last_name = '';
    email = '';

    error = '';
    success = '';
    loading = false;
    data = {};
    response = {};

    /* eslint-disable no-useless-escape */
    emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    onButton() {
        this.register();
    }

    async register() {
        this.loading = true;
        this.error = '';
        this.success = '';
        if (!this.last_name || !this.first_name || !this.email) {
            this.error = this.$i18n.t('account.errors.not_filled');
            this.loading = false;
            return false;
        }
        if (this.checkEmail(this.email)) {
            this.error = this.$i18n.t('account.errors.not_valid_email');
            this.loading = false;
            return false;
        }
        try {
            const request = Vue.api.post('/newsletter-signup');
            request.json = false;
            await request.send(
                JSON.stringify({
                    email: this.email,
                    first_name: this.first_name,
                    last_name: this.last_name,
                }),
            );
            this.success = this.$i18n.t('account.subscribe.success');
        } catch (e) {
            this.error = this.$i18n.t('account.errors.no_connection');
        } finally {
            this.loading = false;
        }
    }

    checkEmail(target) {
        return !this.emailPattern.test(target);
    }
}
</script>
